let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7WmyY")).then(() => parcelRequire('7Hvi3'));